import { useEffect } from "react";
import api from "@/lib/api";

function setMeta(name, content, property = false) {
  if (!content) return;
  const attr = property ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function absolute(url) {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  return window.location.origin + url;
}

export function useSeo(key, overrides) {
  const ovr = JSON.stringify(overrides || {});
  useEffect(() => {
    let active = true;
    const apply = (seo) => {
      if (!active || !seo) return;
      if (seo.title) document.title = seo.title;
      setMeta("description", seo.description);
      setMeta("keywords", seo.keywords);
      setMeta("og:title", seo.title, true);
      setMeta("og:description", seo.description, true);
      if (seo.og_image) setMeta("og:image", absolute(seo.og_image), true);
    };
    api
      .get(`/seo/${key}`)
      .then(({ data }) => apply({ ...data, ...(overrides || {}) }))
      .catch(() => apply(overrides));
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, ovr]);
}
